import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-y-4 gap-x-6 px-4" }
const _hoisted_3 = { class: "grid grid-cols-1 gap-x-6 px-4" }
const _hoisted_4 = { class: "grid grid-cols-2 gap-y-4 gap-x-6 px-4" }
const _hoisted_5 = { class: "w-full flex flex-row justify-between items-center" }
const _hoisted_6 = { class: "flex flex-row ml-1" }
const _hoisted_7 = {
  key: 0,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-xs px-1"
}
const _hoisted_8 = {
  key: 1,
  class: "ml-1 bg-red-lp-600 rounded text-center text-red-lp-1600 font-medium text-xs px-1"
}
const _hoisted_9 = { class: "flex flex-row ml-1" }
const _hoisted_10 = {
  key: 0,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-xs px-1"
}
const _hoisted_11 = {
  key: 1,
  class: "ml-1 bg-red-lp-600 rounded text-center text-red-lp-1600 font-medium text-xs px-1"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "pr-6" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Select = _resolveComponent("Select")!
  const _component_ComponentSelectShipmentId = _resolveComponent("ComponentSelectShipmentId")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Title, { label: "Kriteria Booking" }),
    _createVNode("div", _hoisted_2, [
      (_ctx.formType === 'edit')
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_DataWrapper, { label: "ID Config." }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  disabled: true,
                  modelValue: _ctx.form.commissionId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.commissionId = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, { label: "Kode" }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  disabled: true,
                  modelValue: _ctx.form.commissionCode,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.commissionCode = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(_component_DataWrapper, { label: "Sumber Booking" }, {
        default: _withCtx(() => [
          _createVNode(_component_Select, {
            "is-disabled": _ctx.isInputDisabled,
            onOpenSelect: _ctx.onOpenSelectBookingSource,
            onCloseSelect: _ctx.onCloseSelectBookingSource,
            isOpenMenu: _ctx.isOpenSelectBookingSource,
            value: _ctx.form.commissionBookingSource,
            onChooseSelect: _ctx.onSelectBookingSource,
            dataSelect: _ctx.bookingSourceOptions,
            class: "w-full mt-1.5"
          }, null, 8, ["is-disabled", "onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
        ]),
        _: 1
      }),
      _createVNode(_component_DataWrapper, { label: "Komisi Untuk" }, {
        default: _withCtx(() => [
          _createVNode(_component_Select, {
            "is-disabled": !_ctx.form.commissionBookingSource || _ctx.isInputDisabled,
            onOpenSelect: _ctx.onOpenSelectCommissionFor,
            onCloseSelect: _ctx.onCloseSelectCommissionFor,
            isOpenMenu: _ctx.isOpenSelectCommissionFor,
            value: _ctx.form.commissionFor,
            onChooseSelect: _ctx.onSelectCommissionFor,
            dataSelect: _ctx.commissionForOptions,
            class: "w-full mt-1.5"
          }, null, 8, ["is-disabled", "onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_DataWrapper, { label: "Shipment ID" }, {
        default: _withCtx(() => [
          (_ctx.isShipmentIdMandatory)
            ? (_openBlock(), _createBlock(_component_ComponentSelectShipmentId, {
                key: 0,
                disabled: _ctx.isInputDisabled,
                class: "mt-1.5",
                modelValue: _ctx.form.commissionShipmentId,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.commissionShipmentId = $event))
              }, null, 8, ["disabled", "modelValue"]))
            : (_openBlock(), _createBlock(_component_LpInput, {
                key: 1,
                disabled: true,
                "model-value": '-'
              }))
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_DataWrapper, { label: "Kota Asal" }, {
        default: _withCtx(() => [
          _createVNode(_component_SelectSearch, {
            "is-disabled": _ctx.isInputDisabled,
            onFocus: _ctx.fetchCity,
            class: "mt-1.5",
            onFilter: _ctx.filterCity,
            isLoading: _ctx.isLoadingCity,
            options: _ctx.cityOptions,
            keyName: "name",
            keyValue: "id",
            placeholder: "Pilih kota asal",
            modelValue: _ctx.form.commissionOriginCity,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.commissionOriginCity = $event))
          }, null, 8, ["is-disabled", "onFocus", "onFilter", "isLoading", "options", "modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_DataWrapper, { label: "Kota Tujuan" }, {
        default: _withCtx(() => [
          _createVNode(_component_SelectSearch, {
            "is-disabled": _ctx.isInputDisabled,
            onFocus: _ctx.fetchCity,
            class: "mt-1.5",
            onFilter: _ctx.filterCity,
            isLoading: _ctx.isLoadingCity,
            options: _ctx.cityOptions,
            keyName: "name",
            keyValue: "id",
            placeholder: "Pilih kota tujuan",
            modelValue: _ctx.form.commissionDestinationCity,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.commissionDestinationCity = $event))
          }, null, 8, ["is-disabled", "onFocus", "onFilter", "isLoading", "options", "modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_DataWrapper, { label: "Produk" }, {
        default: _withCtx(() => [
          _createVNode(_component_SelectSearch, {
            "is-disabled": _ctx.isInputDisabled,
            onFocus: _ctx.fetchProduct,
            class: "mt-1.5",
            onFilter: _ctx.filterProduct,
            isLoading: _ctx.isLoadingProduct,
            options: _ctx.productOptions,
            keyName: "name",
            keyValue: "name",
            placeholder: "Pilih produk",
            modelValue: _ctx.form.commissionProduct,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.commissionProduct = $event))
          }, null, 8, ["is-disabled", "onFocus", "onFilter", "isLoading", "options", "modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_DataWrapper, { label: "Komoditas" }, {
        default: _withCtx(() => [
          _createVNode(_component_SelectSearch, {
            id: "select-search_komoditas_buat-konfigurasi-komisi",
            "is-disabled": _ctx.isInputDisabled,
            onFocus: _ctx.fetchCommodity,
            class: "mt-1.5",
            onFilter: _ctx.filterCommodity,
            isLoading: _ctx.isLoadingCommodity,
            options: _ctx.commodityOptions,
            keyName: "name",
            keyValue: "code",
            placeholder: "Pilih komoditas",
            modelValue: _ctx.form.commissionCommodity,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.commissionCommodity = $event)),
            useInfiniteScroll: "",
            onScrolled: _ctx.fetchCommodityListInfiniteScroll
          }, {
            "custom-option": _withCtx(({item}) => [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", null, _toDisplayString(item.name), 1),
                _createVNode("div", _hoisted_6, [
                  (item.isQuarantine)
                    ? (_openBlock(), _createBlock("span", _hoisted_7, " K "))
                    : _createCommentVNode("", true),
                  (item.isDangerousGoods)
                    ? (_openBlock(), _createBlock("span", _hoisted_8, " DG "))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            "selected-info": _withCtx(({selected}) => [
              _createVNode("div", _hoisted_9, [
                (selected && selected.isQuarantine)
                  ? (_openBlock(), _createBlock("span", _hoisted_10, " K "))
                  : _createCommentVNode("", true),
                (selected && selected.isDangerousGoods)
                  ? (_openBlock(), _createBlock("span", _hoisted_11, " DG "))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["is-disabled", "onFocus", "onFilter", "isLoading", "options", "modelValue", "onScrolled"])
        ]),
        _: 1
      })
    ]),
    _hoisted_12
  ]))
}